module.exports = __webpack_public_path__ + "img/esdec.a750db68.png";